module.exports = __webpack_public_path__ + "static/media/Hannachi M., Guebbai H..5d6f0506.pdf";